<template>
  <div>
    <v-card-title>
      Deneme Sınavları
      <v-spacer></v-spacer>
      <c-exam-kind v-if="!$vuetify.breakpoint.mobile" v-model="filters.ExamKindId" @change="getDataFromApi" dense class="mr-2" style="max-width: 140px"></c-exam-kind>
      <v-btn-toggle dense color="primary" mandatory>
        <v-btn v-for="item in ['SON 5 SINAV','TÜM SINAVLAR']" :key="item" @click="changeFilter(item)">
          {{ item }}
        </v-btn>
      </v-btn-toggle>
    </v-card-title>
    <!-- Lesson Results Table -->
    <v-sheet outlined rounded class="mb-4">
      <div class="table-scroll-container">
        <v-simple-table dense class="table-bordered">
          <template v-slot:default>
            <thead style="background-color:#e4e4e4;" class="font-weight-boldest">
            <tr>
              <th rowspan="2" class="text-center" style="vertical-align: middle;"></th>
              <th rowspan="2" class="text-center" style="vertical-align: middle;">Tarih</th>
              <th rowspan="2" class="text-center" style="vertical-align: middle;">Sınav</th>
              <th v-for="lesson in uniqueLessons" :key="lesson" colspan="3" class="text-center">
                {{ lesson }}
              </th>
              <th colspan="4" class="text-center">Toplam</th>
            </tr>
            <tr>
              <template v-for="lesson in uniqueLessons">
                <th :key="`${lesson}-ss`" class="text-center">SS</th>
                <th :key="`${lesson}-d`" class="text-center">D</th>
                <th :key="`${lesson}-y`" class="text-center">Y+B</th>
              </template>
              <th class="text-center">SS</th>
              <th class="text-center">D</th>
              <th class="text-center">Y+B</th>
              <th class="text-center">Net</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(exam, index) in rows" :key="exam.ExamId">
              <td class="text-center">{{ index + 1 }}</td>
              <td class="text-center">{{ exam.ExamDate | formattedDate }}</td>
              <td class="text-center">{{ exam.ExamName }}</td>
              <template v-for="lesson in uniqueLessons">
                <template v-if="getLessonData(exam, lesson)">
                  <td :key="`${exam.ExamId}-${lesson}-ss`" class="text-center">
                    {{ getLessonData(exam, lesson).QuestionCount }}
                  </td>
                  <td :key="`${exam.ExamId}-${lesson}-d`" class="text-center">
                    {{ getLessonData(exam, lesson).CorrectCount }}
                  </td>
                  <td :key="`${exam.ExamId}-${lesson}-y`" class="text-center">
                    {{ getLessonData(exam, lesson).WrongCount + getLessonData(exam, lesson).EmptyCount }}
                  </td>
                </template>
                <template v-else>
                  <td :key="`${exam.ExamId}-${lesson}-ss`" class="text-center"></td>
                  <td :key="`${exam.ExamId}-${lesson}-d`" class="text-center"></td>
                  <td :key="`${exam.ExamId}-${lesson}-y`" class="text-center"></td>
                </template>
              </template>
              <td class="text-center font-weight-bold">{{ getTotalQuestions(exam) }}</td>
              <td class="text-center font-weight-bold">{{ getTotalCorrect(exam) }}</td>
              <td class="text-center font-weight-bold">{{ getTotalWrongAndEmpty(exam) }}</td>
              <td class="text-center font-weight-bold">{{ getTotalNet(exam) }}</td>
            </tr>
            <!-- Average Row -->
            <tr style="background-color:#f5f5f5;" class="font-weight-bold">
              <td class="text-center" colspan="3">ORTALAMA</td>
              <template v-for="lesson in uniqueLessons">
                <td :key="`avg-${lesson}-ss`" class="text-center">{{ getAverageLessonQuestions(lesson) }}</td>
                <td :key="`avg-${lesson}-d`" class="text-center">{{ getAverageLessonCorrect(lesson) }}</td>
                <td :key="`avg-${lesson}-y`" class="text-center">{{ getAverageLessonWrongAndEmpty(lesson) }}</td>
              </template>
              <td class="text-center">{{ getAverageTotalQuestions() }}</td>
              <td class="text-center">{{ getAverageTotalCorrect() }}</td>
              <td class="text-center">{{ getAverageTotalWrongAndEmpty() }}</td>
              <td class="text-center">{{ getAverageTotalNet() }}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-sheet>

    <!-- Point Results Table -->
    <v-sheet outlined rounded>
      <div class="table-scroll-container">
        <v-simple-table dense class="table-bordered">
          <template v-slot:default>
            <thead style="background-color:#e4e4e4;" class="font-weight-boldest">
            <tr>
              <th class="text-center"></th>
              <th class="text-center">Tarih</th>
              <th class="text-center" style="min-width: 200px;">Sınav</th>
              <th class="text-center">Puan Türü</th>
              <th class="text-center">Puan</th>
              <th class="text-center">Genel Sıra</th>
              <th class="text-center">Okul Sırası</th>
              <th class="text-center">Şube Sırası</th>
              <th class="text-center">İlçe Sırası</th>
              <th class="text-center">İl Sırası</th>
              <th class="text-center">Ülke Sırası</th>
              <th class="text-center">Genel Katılım</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(exam, examIndex) in rows">
              <template v-if="exam.Points && exam.Points.length > 0">
                <tr v-for="(point, pointIndex) in exam.Points" :key="`point-${exam.ExamId}-${pointIndex}`">
                  <td class="text-center" v-if="pointIndex === 0" :rowspan="exam.Points.length">{{ examIndex + 1 }}</td>
                  <td class="text-center" v-if="pointIndex === 0" :rowspan="exam.Points.length">{{ exam.ExamDate | formattedDate }}</td>
                  <td v-if="pointIndex === 0" :rowspan="exam.Points.length" style="min-width: 200px;">{{ exam.ExamName }}</td>
                  <td class="text-center">{{ point.PointTypeName }}</td>
                  <td class="text-center">{{ point.Point }}</td>
                  <td class="text-center">{{ point.GeneralRank }}</td>
                  <td class="text-center">{{ point.SchoolRank }}</td>
                  <td class="text-center">{{ point.ClassBranchRank }}</td>
                  <td class="text-center">{{ point.CountyRank || '-' }}</td>
                  <td class="text-center">{{ point.CityRank || '-' }}</td>
                  <td class="text-center">{{ point.CountryRank || '-' }}</td>
                  <td class="text-center">{{ point.GeneralParticipation }}</td>
                </tr>
              </template>
              <tr v-else :key="`point-${exam.ExamId}-empty`">
                <td class="text-center">{{ examIndex + 1 }}</td>
                <td class="text-center">{{ exam.ExamDate | formattedDate }}</td>
                <td style="min-width: 200px;">{{ exam.ExamName }}</td>
                <td class="text-center" colspan="9">-</td>
              </tr>
            </template>
            <!-- Average Row for Points -->
            <tr v-if="getUniquePointTypes().length > 0" style="background-color:#f5f5f5;" class="font-weight-bold">
              <td class="text-center" colspan="3">ORTALAMA</td>
              <td class="text-center" colspan="9">
                <span v-for="(pointType, index) in getUniquePointTypes()" :key="pointType">
                  {{ pointType }}: {{ getAveragePointByType(pointType) }}
                  <span v-if="index < getUniquePointTypes().length - 1"> | </span>
                </span>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service.js'

export default {
  props: ['filters'],
  data() {
    return {
      loading: false,
      rows: [],
      uniqueLessons: []
    }
  },
  mounted() {
    this.filters.IsLimited = true
    this.getDataFromApi()
  },
  methods: {
    getDataFromApi() {
      this.loading = true
      ApiService.setHeader()
      ApiService.post('api/Student/exam-report-table', this.filters)
          .then(({data}) => {
            this.rows = data
            // Extract unique lesson names from all exams
            const lessonSet = new Set()
            data.forEach(exam => {
              if (exam.Lessons && exam.Lessons.length > 0) {
                exam.Lessons.forEach(lesson => {
                  lessonSet.add(lesson.LessonName)
                })
              }
            })
            this.uniqueLessons = Array.from(lessonSet)
            this.loading = false
          })
          .catch(({response}) => {
            ApiService.showError(response)
            this.loading = false
          })
    },

    changeFilter(item) {
      this.filters.IsLimited = item === 'SON 5 SINAV'
      this.getDataFromApi()
    },

    getLessonData(exam, lessonName) {
      if (!exam.Lessons || exam.Lessons.length === 0) return null
      return exam.Lessons.find(l => l.LessonName === lessonName)
    },

    getTotalQuestions(exam) {
      if (!exam.Lessons || exam.Lessons.length === 0) return 0
      return exam.Lessons.reduce((sum, lesson) => sum + lesson.QuestionCount, 0)
    },

    getTotalCorrect(exam) {
      if (!exam.Lessons || exam.Lessons.length === 0) return 0
      return exam.Lessons.reduce((sum, lesson) => sum + lesson.CorrectCount, 0)
    },

    getTotalWrong(exam) {
      if (!exam.Lessons || exam.Lessons.length === 0) return 0
      return exam.Lessons.reduce((sum, lesson) => sum + lesson.WrongCount, 0)
    },

    getTotalEmpty(exam) {
      if (!exam.Lessons || exam.Lessons.length === 0) return 0
      return exam.Lessons.reduce((sum, lesson) => sum + lesson.EmptyCount, 0)
    },

    getTotalWrongAndEmpty(exam) {
      return this.getTotalWrong(exam) + this.getTotalEmpty(exam)
    },

    getTotalNet(exam) {
      if (!exam.Lessons || exam.Lessons.length === 0) return 0
      const totalNet = exam.Lessons.reduce((sum, lesson) => sum + lesson.Net, 0)
      return totalNet.toFixed(2)
    },

    getAverageLessonQuestions(lesson) {
      let totalQuestions = 0
      let count = 0
      this.rows.forEach(exam => {
        const lessonData = this.getLessonData(exam, lesson)
        if (lessonData) {
          totalQuestions += lessonData.QuestionCount
          count++
        }
      })
      return count > 0 ? (totalQuestions / count).toFixed(2) : '-'
    },
    
    getAverageLessonCorrect(lesson) {
      let totalCorrect = 0
      let count = 0
      this.rows.forEach(exam => {
        const lessonData = this.getLessonData(exam, lesson)
        if (lessonData) {
          totalCorrect += lessonData.CorrectCount
          count++
        }
      })
      return count > 0 ? (totalCorrect / count).toFixed(2) : '-'
    },
    
    getAverageLessonWrongAndEmpty(lesson) {
      let totalWrongAndEmpty = 0
      let count = 0
      this.rows.forEach(exam => {
        const lessonData = this.getLessonData(exam, lesson)
        if (lessonData) {
          totalWrongAndEmpty += lessonData.WrongCount + lessonData.EmptyCount
          count++
        }
      })
      return count > 0 ? (totalWrongAndEmpty / count).toFixed(2) : '-'
    },
    
    getAverageTotalQuestions() {
      if (this.rows.length === 0) return '-'
      const totalQuestions = this.rows.reduce((sum, exam) => sum + this.getTotalQuestions(exam), 0)
      return (totalQuestions / this.rows.length).toFixed(2)
    },
    
    getAverageTotalCorrect() {
      if (this.rows.length === 0) return '-'
      const totalCorrect = this.rows.reduce((sum, exam) => sum + this.getTotalCorrect(exam), 0)
      return (totalCorrect / this.rows.length).toFixed(2)
    },
    
    getAverageTotalWrongAndEmpty() {
      if (this.rows.length === 0) return '-'
      const totalWrongAndEmpty = this.rows.reduce((sum, exam) => sum + this.getTotalWrongAndEmpty(exam), 0)
      return (totalWrongAndEmpty / this.rows.length).toFixed(2)
    },
    
    getAverageTotalNet() {
      if (this.rows.length === 0) return '-'
      const totalNet = this.rows.reduce((sum, exam) => sum + parseFloat(this.getTotalNet(exam)), 0)
      return (totalNet / this.rows.length).toFixed(2)
    },
    
    getUniquePointTypes() {
      const pointTypes = new Set()
      this.rows.forEach(exam => {
        if (exam.Points && exam.Points.length > 0) {
          exam.Points.forEach(point => {
            pointTypes.add(point.PointTypeName)
          })
        }
      })
      return Array.from(pointTypes)
    },
    
    getAveragePointByType(pointType) {
      let totalPoint = 0
      let count = 0
      this.rows.forEach(exam => {
        if (exam.Points && exam.Points.length > 0) {
          const pointData = exam.Points.find(p => p.PointTypeName === pointType)
          if (pointData) {
            totalPoint += pointData.Point
            count++
          }
        }
      })
      return count > 0 ? (totalPoint / count).toFixed(2) : '-'
    }
  }
}
</script>

<style scoped>
.table-scroll-container {
  overflow-x: auto;
  overflow-y: auto;
}

th, td {
  padding: 3px !important;
  white-space: nowrap;
}
</style>

